import ContractsTable from './components/ContractsTable';

const ContractsPage = () => {
  return <ContractsTable />;
};

export default ContractsPage;
